import {mapRunningTimeDto} from '@domain/shared'
import {ApiClient} from '@hconnect/apiclient'
import {
  EquipmentRunningTimes,
  RunningTimesEquipmentData,
  RunningTimeType,
  StoppageDto
} from '@hconnect/common/types'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {useQueryClient} from '@tanstack/react-query'
import {useEffect, useState} from 'react'

import {getInitialStoppageData} from '../utils'

export function useDefaultStoppageData({
  runningTimePerformance,
  equipment,
  plantId,
  enabled = true
}: {
  runningTimePerformance?: EquipmentRunningTimes
  equipment: RunningTimesEquipmentData
  plantId: string
  enabled?: boolean
}) {
  const [item, setItem] = useState<Partial<StoppageDto>>()
  const [isLoading, setIsLoading] = useState<boolean>(enabled)
  const queryClient = useQueryClient()
  const enableMainEquipmentPrefilling = useCommonFeatureFlag(FeatureFlagKey.MainEquipmentPrefill, {
    plantId
  })

  useEffect(() => {
    if (!enabled) return

    const fetchData = async () => {
      setIsLoading(true)
      const runningTime = runningTimePerformance?.runningTimes
        ?.filter((rt) => rt.begin !== rt.end)
        .find((rt) => rt.runningTimeType === RunningTimeType.STOPPED && rt.stoppages === undefined)

      if (!runningTime) return

      const defaultValue = await getInitialStoppageData({
        rt: mapRunningTimeDto(runningTime),
        equipment,
        plantId,
        queryClient,
        axiosInstance: ApiClient.axiosInstance,
        enableMainEquipmentPrefilling
      })

      setItem(defaultValue)
      setIsLoading(false)
    }
    if (!item && enabled) {
      void fetchData()
    }
  }, [
    runningTimePerformance,
    equipment,
    plantId,
    item,
    queryClient,
    enableMainEquipmentPrefilling,
    enabled
  ])

  return [item, setItem, isLoading] as const
}
